import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import SEO from "../components/SEO";
import { generateBreadcrumbSchema, websiteSchema } from "../utils/schemaMarkup";

const Blog = () => {
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://www.ceekayenterprise.com/" },
    { name: "Blog", url: "https://www.ceekayenterprise.com/blog" },
  ]);

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [websiteSchema, breadcrumbSchema],
  };

  return (
    <div className="page active">
      <SEO
        title="Industrial Chemicals Blog | Market Trends, Applications & Insights | Ceekay Enterprise"
        description="Stay updated with the latest trends, insights, and information about industrial chemicals. Articles on market trends, agricultural applications, quality control, sustainability, and chemical industry news."
        keywords="chemical industry blog, industrial chemicals news, chemical market trends, agriculture chemicals, chemical applications, chemical industry insights"
        canonical="https://www.ceekayenterprise.com/blog"
        schema={combinedSchema}
      />

      {/* Breadcrumb */}
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Blog</span>
      </nav>

      <div className="blog-header">
        <h1 className="page-title">Our Blog</h1>
        <p className="blog-intro">
          Stay informed with the latest insights, trends, and information about industrial chemicals,
          market dynamics, and industry best practices.
        </p>
      </div>

      <div className="blog-grid">
        {blogPosts.map((post) => (
          <article key={post.id} className="blog-card">
            {post.image && (
              <div className="blog-card-image">
                <Link to={`/blog/${post.slug}`}>
                  <img src={post.image} alt={post.title} loading="lazy" />
                </Link>
              </div>
            )}
            <div className="blog-card-content">
              <div className="blog-meta">
                <span className="blog-category">{post.category}</span>
                <span className="blog-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              </div>
              <h2 className="blog-card-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <div className="blog-card-tags">
                {post.tags.map((tag, index) => (
                  <span key={index} className="blog-tag">{tag}</span>
                ))}
              </div>
              <Link to={`/blog/${post.slug}`} className="blog-read-more">
                Read More →
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Blog;

